export default __webpack_public_path__ + "static/media/capacity.44d3abe1.svg";